import { useUserQuery } from "../../../../../../../api/queries/useUserQuery";

export const useIsBlocked = (id) => {
  const { data: user } = useUserQuery({
    payload: {
      userId: id,
    },
    options: {
      enabled: !!id,
    },
  });

  return Boolean(user?.isBlocked);
}
